/**
 * Personnages diversifiés basés sur le pack Humaans (SVG vectoriels),
 * recolorés via Gemini pour varier teints / tenues / silhouettes.
 * Pas de PNG générés (évite détourage / artefacts).
 *
 * `julia` = personnage principal officiel (`/character-julia.svg`),
 * déjà utilisé dans le panneau assistant : à réutiliser ailleurs sur demande.
 */
export const CHARACTERS = {
  /** Personnage Julia officiel : panneau assistant / identité produit */
  julia: "/character-julia.svg",
  dashboardDesk: "/illustrations/characters/desk.svg",
  dashboardNews: "/illustrations/characters/news.svg",
  dashboardExpert: "/illustrations/characters/expert.svg",
  dashboardProgress: "/illustrations/characters/progress.svg",
  onboarding: "/illustrations/characters/onboarding.svg",
  collaborateur: "/illustrations/characters/collab.svg",
  landing: "/illustrations/characters/landing.svg",
  marketplace: "/illustrations/characters/market.svg",
  guides: "/illustrations/characters/guide.svg",
  manager: "/illustrations/characters/manager.svg",
  welcome: "/illustrations/characters/welcome.svg",
  walk: "/illustrations/characters/walk.svg",
} as const;
